export const unconfirmedSupportNumbers = [0, '0', 'TBC', 'tbc', 'Tbc', '', null, undefined]
